import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useWindowSize from 'hooks/useWindowSize';
import PrivateSection from 'routes/PrivateSection';
import PublicRoutes from 'routes/PublicRoutes';
import { useSelector, useDispatch } from 'react-redux';
import { selectUser, login } from 'features/userSlice';

function Routes() {
    const { pathname } = useLocation();
    // eslint-disable-next-line no-unused-vars
    const [width, height] = useWindowSize();
    const user = useSelector(selectUser);
    const dispatch = useDispatch();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    // Initialize user state from localStorage on app load
    useEffect(() => {
        const token = localStorage.getItem('token');
        const userData = localStorage.getItem('user');

        if (token && userData && !user) {
            try {
                const parsedUser = JSON.parse(userData);
                // Ensure the token matches
                if (parsedUser.token === token) {
                    dispatch(login(parsedUser));
                }
            } catch (error) {
                // If parsing fails, clear invalid data
                console.error('Error parsing user data:', error);
                localStorage.removeItem('user');
                localStorage.removeItem('token');
            }
        }
    }, [user, dispatch]);

    return user ? <PrivateSection /> : <PublicRoutes />;
}

export default Routes;
